import useApi, { ApiOptions } from '../base/useApi';
import JobDTO from '@src/adapters/dto/job/JobDTO';

interface Params {
  job: JobDTO;
}

interface Result {
  job: JobDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/job',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveJobLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveJobLazy;
